import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_entries2aa2t2vhorajh as get_entries,
  AlertCategory_Info_getInstance3jt06v3o3bnmb as AlertCategory_Info_getInstance,
  AlertCategory_ActionNeeded_getInstanceuzezzg1ziuki as AlertCategory_ActionNeeded_getInstance,
  AlertCategory_CriticalActionNeeded_getInstanceh77hzcy879hu as AlertCategory_CriticalActionNeeded_getInstance,
  CrowPayAlertxsn5n3sp58h5 as CrowPayAlert,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
} from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { Notification36ye7lys64zyi as Notification } from '../../../../../../crowpay-shared/com/crowpay/notifications/shared.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import {
  serializerOrContextual1whp5jyfp32aq as serializerOrContextual,
  tryTypeParameterSerializers1jrcyh9alxuh0 as tryTypeParameterSerializers,
} from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  Notification_contente278hdr7b28t as Notification_content,
  Notification_usero4k05uhx7qoy as Notification_user,
  Notification_sendAt157qjqtdxcsgo as Notification_sendAt,
} from '../../../../../../crowpay-shared/com/crowpay/notifications/NotificationFields.mjs';
import { get_read10m44ajihqkgu as get_read } from '../../../../../../crowpay-shared/com/crowpay/CrowPayAlertFields.mjs';
import {
  closePopovers89geeulkriez as closePopovers,
  get_popoverCloseraz5y36f5ki4 as get_popoverCloser,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { MassModification2g7vooufrvzd as MassModification } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/MassModification.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { toSet1glep2u1u9tcb as toSet_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Unread_getInstance2ucj3ofncdx90 as Unread_getInstance,
  NotImportantSemantic_getInstanceqhz8j2q97ips as NotImportantSemantic_getInstance,
  get_withoutPadding21hnjxk91b1qc as get_withoutPadding,
} from '../../theming/appTheme.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_circle12ms3rjf6er3s as get_circle,
  get_trash3qsdn4kaynjmu as get_trash,
  get_notificationBellomfwee2yer2u as get_notificationBell,
} from '../../../icons.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  ConstantLimitReadable29q2jwoe6byet as ConstantLimitReadable,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_bold1rri6ahk98puv as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_windowIsNarrow3aab1t9rdaelq as get_windowIsNarrow,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from './crowpay.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance } from '../../theming/sections.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  substringAfter35b3qhto7hchb as substringAfter,
  substringAfter1hku067gwr5ve as substringAfter_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_getInstance3qvaw4651ntmp as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { get_AutoRoutes3nqqi7p59slz8 as get_AutoRoutes } from '../../autoroutes.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './AppDimensions.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { children3sl29z5no2wyp as children } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { countBubbleqc8faq0macxu as countBubble } from '../iconShortcuts.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AlertSection_All_instance;
var AlertSection_Info_instance;
var AlertSection_Actions_instance;
function values() {
  return [AlertSection_All_getInstance(), AlertSection_Info_getInstance(), AlertSection_Actions_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var AlertSection_entriesInitialized;
function AlertSection_initEntries() {
  if (AlertSection_entriesInitialized)
    return Unit_instance;
  AlertSection_entriesInitialized = true;
  AlertSection_All_instance = AlertSection().xgf('All', 0, toSet(get_entries()));
  AlertSection_Info_instance = AlertSection().ygf('Info', 1, [AlertCategory_Info_getInstance()]);
  AlertSection_Actions_instance = AlertSection().ygf('Actions', 2, [AlertCategory_ActionNeeded_getInstance(), AlertCategory_CriticalActionNeeded_getInstance()]);
}
var $ENTRIES;
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.kfw_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.zgf_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  // Inline function 'com.crowpay.utils.modify2' call
  var this_2 = tmp_0.eeo(tmp$ret$1.n8m_1);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(CrowPayAlert()), arrayOf([]), false))]), false));
  var tmp$ret$2 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  // Inline function 'com.crowpay.notifications.content' call
  var this_4 = new (DataClassPathSelf())(tmp$ret$2);
  // Inline function 'kotlin.let' call
  var it = ensureNotNull(tryTypeParameterSerializers(this_4.j2j()));
  var tmp_3 = it[0];
  var tmp_4 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var tmp_5 = it[1];
  var tmp$ret$6 = this_4.prop(new (Notification_content())(tmp_4, isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE()));
  this_3.e44(get_read(tmp$ret$6), true);
  var tmp$ret$10 = this_3.o1r();
  var tmp_6 = this_2.len(tmp$ret$10, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  closePopovers($this.agg_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.tfw().hfg_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(CrowPayAlert()), arrayOf([]), false))]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  // Inline function 'com.crowpay.notifications.user' call
  // Inline function 'kotlin.let' call
  var it_0 = ensureNotNull(tryTypeParameterSerializers(it.j2j()));
  var tmp_2 = it_0[0];
  var tmp_3 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var tmp_4 = it_0[1];
  var tmp$ret$5 = it.prop(new (Notification_user())(tmp_3, isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE()));
  var tmp_5 = eq(tmp$ret$5, session.efv_1);
  // Inline function 'com.crowpay.notifications.content' call
  // Inline function 'kotlin.let' call
  var it_1 = ensureNotNull(tryTypeParameterSerializers(it.j2j()));
  var tmp_6 = it_1[0];
  var tmp_7 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
  var tmp_8 = it_1[1];
  var tmp$ret$8 = it.prop(new (Notification_content())(tmp_7, isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE()));
  var tmp_9 = and(tmp_5, eq(get_read(tmp$ret$8), false));
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_10 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(CrowPayAlert()), arrayOf([]), false))]), false));
  var tmp$ret$12 = isInterface(tmp_10, KSerializer()) ? tmp_10 : THROW_CCE();
  // Inline function 'com.crowpay.notifications.content' call
  var this_2 = new (DataClassPathSelf())(tmp$ret$12);
  // Inline function 'kotlin.let' call
  var it_2 = ensureNotNull(tryTypeParameterSerializers(this_2.j2j()));
  var tmp_11 = it_2[0];
  var tmp_12 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var tmp_13 = it_2[1];
  var tmp$ret$16 = this_2.prop(new (Notification_content())(tmp_12, isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE()));
  this_1.e44(get_read(tmp$ret$16), true);
  var tmp$ret$20 = this_1.o1r();
  var tmp_14 = tmp_0.cfn(new (MassModification())(tmp_9, tmp$ret$20), $completion);
  if (tmp_14 === get_COROUTINE_SUSPENDED())
    tmp_14 = yield tmp_14;
  var tmp_15 = UserNotifications$render$slambda$lambda;
  session.kfw_1.ceo(tmp_15, UserNotifications$render$slambda$lambda_0);
  return Unit_instance;
}
function UserNotifications$render$slambda$lambda(it) {
  return !it.q8m_1.d5t_1;
}
function UserNotifications$render$slambda$lambda_0(it) {
  return it.x8m(VOID, VOID, VOID, it.q8m_1.i5t(VOID, VOID, VOID, VOID, true));
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bgg_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var n = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.crowpay.utils.modify2' call
  var this_2 = tmp_0.kfw_1.eeo(n.n8m_1);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(CrowPayAlert()), arrayOf([]), false))]), false));
  var tmp$ret$2 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'com.crowpay.notifications.content' call
  var this_4 = new (DataClassPathSelf())(tmp$ret$2);
  // Inline function 'kotlin.let' call
  var it = ensureNotNull(tryTypeParameterSerializers(this_4.j2j()));
  var tmp_2 = it[0];
  var tmp_3 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var tmp_4 = it[1];
  var tmp$ret$6 = this_4.prop(new (Notification_content())(tmp_3, isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE()));
  this_3.e44(get_read(tmp$ret$6), !n.q8m_1.d5t_1);
  var tmp$ret$10 = this_3.o1r();
  var tmp_5 = this_2.len(tmp$ret$10, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp0_safe_receiver = get_popoverCloser($this.cgg_1);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.kfw_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.dgg_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.eeo(tmp$ret$1.n8m_1).iem($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp0_safe_receiver = get_popoverCloser($this.egg_1);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  return Unit_instance;
}
var AlertSectionClass;
function AlertSection() {
  if (AlertSectionClass === VOID) {
    class $ extends Enum() {
      static xgf(name, ordinal, categories) {
        var $this = this.c4(name, ordinal);
        $this.wgf_1 = categories;
        return $this;
      }
      static ygf(name, ordinal, categories) {
        return this.xgf(name, ordinal, toSet_0(categories));
      }
    }
    initMetadataForClass($, 'AlertSection');
    AlertSectionClass = $;
  }
  return AlertSectionClass;
}
function unreadMarker($this, _this__u8e3s4, shown) {
  return _this__u8e3s4.jbb(_this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, shown), _this__u8e3s4.hbb(Unread_getInstance())), icon(_this__u8e3s4, resize(get_circle(Companion_getInstance()), get_rem(0.7)), 'unread'));
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton_7rqfsq(_this__u8e3s4, $notification) {
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$0 = _this__u8e3s4.hbb(ButtonSemantic_getInstance());
  var tmp = _this__u8e3s4.ibb(_this__u8e3s4.ibb(tmp$ret$0, get_compact(_this__u8e3s4)), _this__u8e3s4.hbb(NotImportantSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (MenuButton())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var $this$menuButton = view;
  $this$menuButton.bc4(Companion_getInstance_0().fcr_1);
  $this$menuButton.yc3_1 = true;
  $this$menuButton.jbb(get_centered($this$menuButton), icon($this$menuButton, resize(Companion_getInstance().ecg_1, get_rem(1.2)), 'options'));
  $this$menuButton.ec4(($this$opensMenu) => {
    $this$opensMenu.eba(get_rem_0(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$opensMenu.pc());
    var tmp0_elvis_lhs = $this$opensMenu.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
    $this$opensMenu.ebb(p, view);
    view.xbm(true);
    view.zb8(get_px(0));
    var tmp = get_textButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
    view_1.bbs(Align_Center_getInstance());
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl_2(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_2(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$1 = $this$reactiveScope.baj($notification).q8m_1.d5t_1 ? 'Mark As Unread' : 'Mark As Read';
      this_0.set(tmp$ret$1);
      return Unit_instance;
    });
    view_0.fbb(p_1, view_1);
    onClick(view_0, VOID, VOID, UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw_0($notification, $this$menuButton));
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    greySeparator(view);
    var tmp_2 = get_deleteButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    var tmp_3 = view_2.ibb(get_centered(view_2), get_compact(view_2));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    view_3.xbm(false);
    view_3.jbb(get_centered(view_3), icon(view_3, resize(get_trash(Companion_getInstance()), get_rem(0.8)), 'delete'));
    view_3.jbb(get_centered(view_3), body(view_3, 'Delete'));
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_3, view_3);
    onClick(view_2, VOID, VOID, UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw_2($notification, $this$menuButton));
    view.fbb(p_2, view_2);
    view.jbb(tmp_2, view_2);
    $this$opensMenu.fbb(p, view);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function UserNotifications$notifications$lambda($this$remember) {
  var tmp0_safe_receiver = $this$remember.baj(get_rawSession());
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(CrowPayAlert()), arrayOf([]), false))]), false));
    var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    // Inline function 'com.crowpay.notifications.user' call
    var this_0 = new (DataClassPathSelf())(tmp$ret$0);
    // Inline function 'kotlin.let' call
    var it = ensureNotNull(tryTypeParameterSerializers(this_0.j2j()));
    var tmp_1 = it[0];
    var tmp_2 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    var tmp_3 = it[1];
    var tmp$ret$4 = this_0.prop(new (Notification_user())(tmp_2, isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE()));
    var tmp_4 = eq(tmp$ret$4, tmp0_safe_receiver.efv_1);
    // Inline function 'com.lightningkite.lightningdb.sort' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (SortBuilder())();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_5 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(CrowPayAlert()), arrayOf([]), false))]), false));
    var tmp$ret$8 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$8);
    // Inline function 'com.crowpay.notifications.content' call
    // Inline function 'kotlin.let' call
    var it_1 = ensureNotNull(tryTypeParameterSerializers(it_0.j2j()));
    var tmp_6 = it_1[0];
    var tmp_7 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
    var tmp_8 = it_1[1];
    var tmp$ret$12 = it_0.prop(new (Notification_content())(tmp_7, isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE()));
    this_1.m4a(get_read(tmp$ret$12));
    // Inline function 'com.crowpay.notifications.sendAt' call
    // Inline function 'kotlin.let' call
    var it_2 = ensureNotNull(tryTypeParameterSerializers(it_0.j2j()));
    var tmp_9 = it_2[0];
    var tmp_10 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
    var tmp_11 = it_2[1];
    var tmp$ret$15 = it_0.prop(new (Notification_sendAt())(tmp_10, isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE()));
    this_1.n4a(tmp$ret$15);
    var tmp$ret$19 = this_1.o1r();
    tmp = tmp0_safe_receiver.kfw_1.kdw(new (Query())(tmp_4, tmp$ret$19, VOID, 500));
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? new (ConstantLimitReadable())(emptyList()) : tmp1_elvis_lhs;
}
function UserNotifications$render$lambda($this$shownWhen) {
  return !$this$shownWhen.baj(get_windowIsNarrow());
}
function UserNotifications$render$lambda_0($section) {
  return ($this$specCenteredContent) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$specCenteredContent.pc());
    var tmp0_elvis_lhs = $this$specCenteredContent.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
    $this$specCenteredContent.ebb(p, view);
    view.xbm(false);
    var tmp = get_centered(view);
    var tmp_0 = UserNotifications_getInstance();
    view.jbb(tmp, unreadMarker(tmp_0, view, ($this$unreadMarker) => {
      var tmp0 = $this$unreadMarker.baj($this$unreadMarker.baj(UserNotifications_getInstance().ggg_1));
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(tmp0, Collection())) {
          tmp = tmp0.i1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!element.q8m_1.d5t_1 && $section.wgf_1.t1(element.q8m_1.b5t_1)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      return tmp$ret$0;
    }));
    view.jbb(get_centered(view), body(view, $section.a4_1));
    $this$specCenteredContent.fbb(p, view);
    return view;
  };
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function UserNotifications$render$lambda_1($this$remember) {
  var categories = $this$remember.baj(UserNotifications_getInstance().hgg_1).wgf_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$remember.baj($this$remember.baj(UserNotifications_getInstance().ggg_1));
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (categories.t1(element.q8m_1.b5t_1)) {
      destination.v(element);
    }
  }
  return destination;
}
function UserNotifications$render$lambda_2(it) {
  return it.n8m_1;
}
function UserNotifications$render$lambda_3($this$children, notification) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$children.pc());
  var tmp0_elvis_lhs = $this$children.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$children : tmp0_elvis_lhs;
  $this$children.ebb(p, view);
  view.xbm(false);
  dynamicTheme(view, ($this$dynamicTheme) => $this$dynamicTheme.baj(notification).q8m_1.d5t_1 ? null : get_withoutPadding(SectionSemantic_getInstance()));
  view.zb8(get_px(0));
  var tmp = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Link())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_0 = get_compact(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp$ret$0 = format($this$reactiveScope.baj(notification).o8m_1.l8j_1, Formats_getInstance().k8z_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_1.fbb(p_2, view_2);
  var tmp_3 = get_bold(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.ebb(p_3, view_3);
  view_3.xbm(false);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.jba(view_4.ob6_1.ybe(SubtitleSemantic_getInstance()));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_0(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_0(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp$ret$7 = $this$reactiveScope.baj(notification).q8m_1.z5s_1;
    this_1.set(tmp$ret$7);
    return Unit_instance;
  });
  view_3.fbb(p_4, view_4);
  view_1.fbb(p_3, view_3);
  view_1.jbb(tmp_3, view_3);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_5 = view_1.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
  view_1.ebb(p_5, view_5);
  view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_6 = KMutableProperty0();
  var tmp_7 = TextView$_get_content_$ref_4pzcwl_1(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_1(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$18 = $this$reactiveScope.baj(notification).q8m_1.a5t_1;
    this_2.set(tmp$ret$18);
    return Unit_instance;
  });
  view_1.fbb(p_5, view_5);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  view_0.tbw(UserNotifications$render$lambda$slambda_0(notification, view_0));
  var tmp_8 = KMutableProperty0();
  var tmp_9 = Link$_get_to_$ref_jq7esp(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('to', 0, tmp_8, tmp_9, Link$_set_to_$ref_i9gu5x(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.baj(notification).q8m_1.e5t_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : substringAfter(tmp0_safe_receiver, '://');
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : substringAfter_0(tmp1_safe_receiver, _Char___init__impl__6a9atx(47));
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = Companion_getInstance_1().bd7(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = tmp;
    var tmp_0;
    if (tmp3_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = get_AutoRoutes().xd6(tmp3_safe_receiver);
    }
    var tmp4_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp4_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      var it = tmp4_safe_receiver;
      tmp_1 = () => it;
    }
    var tmp$ret$35 = tmp_1;
    this_3.set(tmp$ret$35);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  var read = lens(notification, UserNotifications$render$lambda$lambda);
  view_6.jbb(shownWhen(view_6, VOID, ($this$shownWhen) => $this$shownWhen.baj(read)), render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton_7rqfsq(view_6, notification));
  var tmp_10 = get_atTopCenter(view_6);
  view_6.jbb(view_6.ibb(tmp_10, shownWhen(view_6, VOID, ($this$shownWhen) => !$this$shownWhen.baj(read))), render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton_7rqfsq(view_6, notification));
  var tmp_11 = get_centered(view_6);
  var tmp_12 = UserNotifications_getInstance();
  view_6.jbb(tmp_11, unreadMarker(tmp_12, view_6, ($this$unreadMarker) => !$this$unreadMarker.baj(notification).q8m_1.d5t_1));
  view.fbb(p_6, view_6);
  $this$children.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var UserNotifications$render$lambda$slambdaClass;
function UserNotifications$render$lambda$slambda() {
  if (UserNotifications$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor($notification, $$this$link) {
        this.zgf_1 = $notification;
        this.agg_1 = $$this$link;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserNotifications$render$lambda$slambdaClass = $;
  }
  return UserNotifications$render$lambda$slambdaClass;
}
function UserNotifications$render$lambda$slambda_0($notification, $$this$link) {
  var i = new (UserNotifications$render$lambda$slambda())($notification, $$this$link);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
function UserNotifications$render$lambda$lambda(it) {
  return it.q8m_1.d5t_1;
}
function UserNotifications$render$lambda_4($this$shownDefaultFalse) {
  return $this$shownDefaultFalse.baj($this$shownDefaultFalse.baj(UserNotifications_getInstance().ggg_1)).i1();
}
function UserNotifications$render$lambda_5($this$shownWhen) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !$this$shownWhen.baj($this$shownWhen.baj(UserNotifications_getInstance().ggg_1)).i1();
}
var UserNotifications$render$slambdaClass;
function UserNotifications$render$slambda() {
  if (UserNotifications$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserNotifications$render$slambdaClass = $;
  }
  return UserNotifications$render$slambdaClass;
}
function UserNotifications$render$slambda_0() {
  var i = new (UserNotifications$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function UserNotifications$renderUnreadCount$lambda$lambda($this$shownDefaultFalse) {
  var tmp0 = $this$shownDefaultFalse.baj($this$shownDefaultFalse.baj(UserNotifications_getInstance().ggg_1));
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!element.q8m_1.d5t_1) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function UserNotifications$renderUnreadCount$lambda($this$countBubble) {
  var tmp0 = $this$countBubble.baj($this$countBubble.baj(UserNotifications_getInstance().ggg_1));
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!element.q8m_1.d5t_1) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$0 = count;
  }
  return tmp$ret$0;
}
function UserNotifications$navButton$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function UserNotifications$navButton$lambda_0($this$opensMenu) {
  $this$opensMenu.hba(Edges().ad0(get_AppDimensions().wg1_1).gd0(VOID, VOID, VOID, get_rem_0(1)));
  var tmp0_height = get_rem_0(40);
  var tmp1_width = get_rem_0(28);
  $this$opensMenu.jbb(sizeConstraints($this$opensMenu, VOID, VOID, VOID, VOID, VOID, tmp1_width, tmp0_height), UserNotifications_getInstance().ud6($this$opensMenu));
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass;
function UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw() {
  if (UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass === VOID) {
    class $ {
      constructor($$notification, $$this$menuButton) {
        this.bgg_1 = $$notification;
        this.cgg_1 = $$this$menuButton;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass = $;
  }
  return UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass;
}
function UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw_0($$notification, $$this$menuButton) {
  var i = new (UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw())($$notification, $$this$menuButton);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass_0;
function UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw_1() {
  if (UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass_0 === VOID) {
    class $ {
      constructor($$notification, $$this$menuButton) {
        this.dgg_1 = $$notification;
        this.egg_1 = $$this$menuButton;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass_0 = $;
  }
  return UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhswClass_0;
}
function UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw_2($$notification, $$this$menuButton) {
  var i = new (UserNotifications$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moreOptionsButton$lambda$slambda_w5rhsw_1())($$notification, $$this$menuButton);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function AlertSection_All_getInstance() {
  AlertSection_initEntries();
  return AlertSection_All_instance;
}
function AlertSection_Info_getInstance() {
  AlertSection_initEntries();
  return AlertSection_Info_instance;
}
function AlertSection_Actions_getInstance() {
  AlertSection_initEntries();
  return AlertSection_Actions_instance;
}
var UserNotificationsClass;
function UserNotifications() {
  if (UserNotificationsClass === VOID) {
    class $ {
      constructor() {
        UserNotifications_instance = this;
        this.fgg_1 = new (Constant())(_Constant___init__impl__v45mub('Alerts'));
        var tmp = this;
        tmp.ggg_1 = remember(VOID, VOID, VOID, UserNotifications$notifications$lambda);
        this.hgg_1 = Signal().fak(AlertSection_All_getInstance());
      }
      ucv() {
        return this.fgg_1;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        var $this$col = view;
        // Inline function 'com.lightningkite.kiteui.views.direct.scrollingHorizontally' call
        // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
        var vertical = false;
        var horizontal = true;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = $this$col.bbb_1;
        var tmp = $this$col;
        tmp.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          (new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal, vertical)).odj(get_viewIsWide($this$col));
          return Unit_instance;
        };
        Companion_getInstance_2();
        var tmp_0 = Companion_getInstance_2();
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())($this$col.pc());
        var tmp0_elvis_lhs_0 = $this$col.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? $this$col : tmp0_elvis_lhs_0;
        $this$col.ebb(p_0, view_0);
        view_0.xbm(false);
        var tmp_1 = view_0.ibb(shownWhen(view_0, VOID, UserNotifications$render$lambda), get_centered(view_0));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_2 = view_1.tb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Alerts') === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = 'Alerts';
        }
        tmp_2.fbu(tmp_3);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_1, view_1);
        var _iterator__ex2g4s = get_entries_0().m1();
        while (_iterator__ex2g4s.n1()) {
          var section = _iterator__ex2g4s.o1();
          var tmp_4 = get_centered(view_0);
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var tmp$ret$11 = view_0.hbb(ButtonSemantic_getInstance());
          var tmp_5 = view_0.ibb(view_0.ibb(tmp_4, tmp$ret$11), get_compact(view_0));
          // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RadioToggleButton())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.ebb(p_2, view_2);
          view_2.xah(view_2.zc8_1, equalTo(UserNotifications_getInstance().hgg_1, section));
          specCenteredContent(view_2, VOID, UserNotifications$render$lambda_0(section));
          view_0.fbb(p_2, view_2);
          view_0.jbb(tmp_5, view_2);
        }
        $this$col.fbb(p_0, view_0);
        $this$col.jbb(tmp_0, view_0);
        greySeparator($this$col);
        var tmp_6 = $this$col.ibb(get_expanding($this$col), get_compact($this$col));
        // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (Recycler2())($this$col, true);
        var $this$recyclerView = this_0;
        var tmp_7 = KMutableProperty0();
        var tmp_8 = RowOrCol$_get_shown_$ref_m8lfse($this$col);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('shown', 0, tmp_7, tmp_8, RowOrCol$_set_shown_$ref_7290m6($this$col));
        reactiveScope($this$col, ($this$reactiveScope) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          var tmp$ret$20 = !$this$reactiveScope.baj($this$reactiveScope.baj(UserNotifications_getInstance().ggg_1)).i1();
          this_1.set(tmp$ret$20);
          return Unit_instance;
        });
        reactive($this$recyclerView, ($this$reactive) => {
          var limiter = $this$reactive.baj(UserNotifications_getInstance().ggg_1);
          var tmp;
          if ($this$reactive.baj($this$recyclerView.ndd_1) >= (limiter.pe1() - 10 | 0)) {
            limiter.oe1(limiter.pe1() + 25 | 0);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        var tmp_9 = remember(VOID, VOID, VOID, UserNotifications$render$lambda_1);
        var tmp_10 = UserNotifications$render$lambda_2;
        children($this$recyclerView, tmp_9, tmp_10, UserNotifications$render$lambda_3);
        $this$col.jbb(tmp_6, this_0);
        var tmp_11 = get_expanding($this$col);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Frame())($this$col.pc());
        var tmp0_elvis_lhs_3 = $this$col.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? $this$col : tmp0_elvis_lhs_3;
        $this$col.ebb(p_3, view_3);
        shownDefaultFalse(view_3, UserNotifications$render$lambda_4);
        var tmp_12 = view_3.ibb(get_centered(view_3), colored(view_3, AppColors_getInstance().ffz_1.xg9_1));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Nothing Yet...';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        view_4.jba(view_4.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_13 = view_4.tb5_1;
        var tmp_14;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_14 = '\xA0';
        } else {
          tmp_14 = content;
        }
        tmp_13.fbu(tmp_14);
        view_3.fbb(p_4, view_4);
        view_3.jbb(tmp_12, view_4);
        $this$col.fbb(p_3, view_3);
        $this$col.jbb(tmp_11, view_3);
        var tmp_15 = get_centered($this$col);
        var tmp_16 = $this$col.ibb($this$col.ibb(tmp_15, shownWhen($this$col, VOID, UserNotifications$render$lambda_5)), get_textButton($this$col));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())($this$col.pc());
        var tmp0_elvis_lhs_5 = $this$col.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? $this$col : tmp0_elvis_lhs_5;
        $this$col.ebb(p_5, view_5);
        specCenteredText(view_5, 'Mark All As Read');
        onClick(view_5, VOID, VOID, UserNotifications$render$slambda_0());
        $this$col.fbb(p_5, view_5);
        $this$col.jbb(tmp_16, view_5);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      igg(writer) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = writer.bbb_1;
        var tmp = writer;
        tmp.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          shownDefaultFalse(_this__u8e3s4, UserNotifications$renderUnreadCount$lambda$lambda);
          return Unit_instance;
        };
        var tmp$ret$1 = Companion_getInstance_2();
        var tmp_0 = writer.ibb(tmp$ret$1, writer.hbb(Unread_getInstance()));
        return writer.jbb(tmp_0, countBubble(writer, VOID, UserNotifications$renderUnreadCount$lambda));
      }
      jgg(writer, setup) {
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (MenuButton())(writer.pc());
        var tmp0_elvis_lhs = writer.cbb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.ebb(p, view);
        setup(view);
        view.yc3_1 = true;
        view.bc4(Companion_getInstance_0().zcq_1);
        view.jbb(colored(view, AppColors_getInstance().cfz_1.xg9_1), icon(view, get_notificationBell(Companion_getInstance()), 'notifications'));
        view.jbb(get_atTopEnd(view), UserNotifications_getInstance().igg(view));
        view.ec4(UserNotifications$navButton$lambda_0);
        writer.fbb(p, view);
        return view;
      }
      kgg(writer, setup, $super) {
        var tmp;
        if (setup === VOID) {
          tmp = UserNotifications$navButton$lambda;
        } else {
          tmp = setup;
        }
        setup = tmp;
        return $super === VOID ? this.jgg(writer, setup) : $super.jgg.call(this, writer, setup);
      }
    }
    initMetadataForObject($, 'UserNotifications', VOID, VOID, [Page()]);
    UserNotificationsClass = $;
  }
  return UserNotificationsClass;
}
var UserNotifications_instance;
function UserNotifications_getInstance() {
  if (UserNotifications_instance === VOID)
    new (UserNotifications())();
  return UserNotifications_instance;
}
//region block: exports
export {
  UserNotifications_getInstance as UserNotifications_getInstance3eyit5zuwe2sg,
};
//endregion

//# sourceMappingURL=UserNotifications.mjs.map
